<script lang="ts" setup>
usePageSeo('seoStoryTitle', 'seoStoryDescription');

const { t } = useI18n();

const storyParagraphs = computed(() => {
  const fullText = t('storySplit') as string;
  // Splitting by period followed by space to get cleaner paragraphs
  return fullText.split(/(?<=\.)\s+/).filter(p => p.trim().length > 0);
});
</script>

<template>
  <div class="story-page">
    <Hero
      :title="$t('Our Story')"
      :subtitle="$t('storySubtitle')"
      backgroundImage="https://res.cloudinary.com/dlct0dnwt/image/upload/q_auto:eco/v1743292001/refuge/2025/3PMA7289_iqzgsu.jpg"
    />

    <div class="editorial-container">
      <div class="story-content">
        <p v-for="(paragraph, index) in storyParagraphs" :key="index" class="story-paragraph">
          {{ paragraph }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.story-page
  width: 100%
  padding-bottom: 8rem

.editorial-container
  max-width: 850px
  margin: 0 auto
  padding: 0 2rem

.story-content
  position: relative
  margin-top: 2rem

.story-paragraph
  font-size: 1.25rem
  line-height: 1.8
  margin-bottom: 2.5rem
  opacity: 0.9
  font-weight: 400

  &:first-of-type
    font-size: 1.75rem
    font-weight: 700
    line-height: 1.5
    margin-bottom: 3rem
    opacity: 1
    color: $color-primary

@media (max-width: 768px)
  .editorial-container
    padding: 0 1.5rem
  .story-paragraph
    font-size: 1.1rem
    margin-bottom: 1.5rem
    &:first-of-type
      font-size: 1.4rem
      margin-bottom: 2rem
</style>
